import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute() {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#071A2F] text-white">
                <div className="flex flex-col items-center gap-3">
                    <Sparkles className="h-7 w-7 text-teal-300 animate-pulse" />
                    <p className="text-sm text-slate-400 font-mono">
                        Restoring your session…
                    </p>
                </div>
            </div>
        );
    }

    if (!user) {
        return (
            <Navigate
                to="/login"
                replace
                state={{ from: location.pathname + location.search }}
            />
        );
    }

    return <Outlet />;
}
